import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/data-not-found.svg'


const _hoisted_1 = { class: "flex flex-col font-montserrat overflow-hidden relative h-screen" }
const _hoisted_2 = {
  key: 0,
  class: "w-full h-full bg-white justify-center items-center flex flex-col mx-auto py-20 text-12px xxl:text-14px overflow-hidden"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-32 mt-8 mx-auto",
  alt: "no_data"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-300 py-2 font-bold" }, " Tidak ada hasil yang ditemukan ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-300 py-2" }, " Apa yang anda cari tidak ditemukan atau tidak ada ", -1)
const _hoisted_6 = {
  key: 1,
  class: "w-full h-full bg-white justify-center items-center flex flex-col mx-auto py-20 text-12px xxl:text-14px overflow-hidden border-t border-gray-lp-200"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-32 mt-8 mx-auto",
  alt: "not_found"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-300 py-2 font-bold" }, " Data tidak ditemukan pada halaman ini ", -1)
const _hoisted_9 = { class: "absolute w-full bottom-0" }
const _hoisted_10 = { class: "overflow-y-auto h-screen pb-16" }
const _hoisted_11 = { class: "absolute w-full bottom-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_TableLazyLoad = _resolveComponent("TableLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_TableV1 = _resolveComponent("TableV1")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      isSearchable: true,
      isSelectStatus: true,
      placeholder: "Cari nama lokasi",
      searchValue: _ctx.search,
      searchAction: _ctx.onSearch,
      clearSearch: _ctx.clearSearch,
      statusData: _ctx.statusData,
      onOpenStatusSelect: _ctx.onOpenStatusSelect,
      onCloseStatusSelect: _ctx.onCloseStatusSelect,
      onSelectStatus: _ctx.onSelectStatus,
      valueStatus: _ctx.statusName,
      statusSelect: _ctx.statusSelect
    }, null, 8, ["searchValue", "searchAction", "clearSearch", "statusData", "onOpenStatusSelect", "onCloseStatusSelect", "onSelectStatus", "valueStatus", "statusSelect"]),
    _withDirectives(_createVNode(_component_TableLazyLoad, { columns: _ctx.columns }, null, 8, ["columns"]), [
      [_vShow, _ctx.isLoading]
    ]),
    _withDirectives(_createVNode(_component_ErrorMessage, {
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.getListData
    }, null, 8, ["errorType", "onTryAgain"]), [
      [_vShow, _ctx.isError && !_ctx.isLoading]
    ]),
    (_ctx.cityListData.length === 0 && !_ctx.isLoading && _ctx.page === 1 && !_ctx.isError)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (_ctx.cityListData.length === 0 && !_ctx.isLoading && _ctx.page !== 1)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Pagination, {
              onNext: _ctx.nextPage,
              onPrevious: _ctx.prevPage,
              page: _ctx.page,
              toPage: _ctx.toPage
            }, null, 8, ["onNext", "onPrevious", "page", "toPage"])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", _hoisted_10, [
      _createVNode(_component_TableV1, {
        columns: _ctx.columns,
        data: _ctx.cityListData,
        class: "my-2",
        onClick: _ctx.onClickRow,
        isDetailAble: _ctx.isDetailAble
      }, null, 8, ["columns", "data", "onClick", "isDetailAble"])
    ], 512), [
      [_vShow, !_ctx.isLoading && _ctx.cityListData.length !== 0 && !_ctx.isError]
    ]),
    _withDirectives(_createVNode("div", _hoisted_11, [
      _createVNode(_component_Pagination, {
        onNext: _ctx.nextPage,
        onPrevious: _ctx.prevPage,
        page: _ctx.page,
        isButtonNext: _ctx.cityListData.length >= _ctx.limit,
        totalData: _ctx.cityListData.length,
        toPage: _ctx.toPage
      }, null, 8, ["onNext", "onPrevious", "page", "isButtonNext", "totalData", "toPage"])
    ], 512), [
      [_vShow, !_ctx.isLoading && _ctx.cityListData.length !== 0 && !_ctx.isError]
    ])
  ]))
}